import {createContext} from 'react';
import type {KioskoContextValue} from './types';

export const KioskoContext = createContext<KioskoContextValue | null>(null);

KioskoContext.displayName = 'KioskoContext';
